import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import OfferBanner from './OfferBanner';
import { TypeAnimation } from 'react-type-animation';
import config from '../config';

const Header = ({ openModal }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleFaqClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const faqSection = document.getElementById('faq');
        if (faqSection) faqSection.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    } else {
      const faqSection = document.getElementById('faq');
      if (faqSection) faqSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const activeClass = 'text-orange-600 font-semibold border-b-2 border-orange-600';

  return (
    <header className="sticky top-0 z-50">
      {/* <OfferBanner /> */}

      <div className="bg-white/80 backdrop-blur-md shadow-md text-gray-800 px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo & Tagline */}
          <div className="flex items-center gap-4">
            <img src="/ssrlogo3.png" alt="SSRPRO Logo" className="w-12 h-auto" />
            <div className="flex flex-col">
              <div className="text-2xl font-bold">
                <Link to="/" className="hover:text-orange-500 transition-colors">
                  myBOQ
                </Link>
              </div>
              <TypeAnimation
                sequence={[
                  'Estimate.', 1500,
                  'Automate.', 1500,
                  'Comply.', 1500,
                  'Estimate. Automate. Comply.', 2500
                ]}
                speed={50}
                wrapper="span"
                repeat={Infinity}
                className="text-xs italic text-gray-600 tracking-wide"
              />
            </div>
          </div>

          {/* Hamburger Toggle */}
          <div className="md:hidden">
            <button onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/" className={`font-bold text-lg hover:text-orange-500 transition-colors duration-200 ${isActive('/') ? activeClass : ''}`}>Home</Link>
            <Link to="/features" className={`font-semibold hover:text-orange-500 transition-colors duration-200 ${isActive('/features') ? activeClass : ''}`}>Features</Link>
            
            {/* 🆕 Blog link */}
            <Link to="/blog" className={`font-semibold hover:text-orange-500 transition-colors duration-200 ${isActive('/blog') ? activeClass : ''}`}>Blog</Link>
            
            <button onClick={handleFaqClick} className="font-semibold hover:text-orange-500 transition-colors duration-200">FAQ</button>

            <button
              onClick={() => window.open(config.signInUrl, '_blank')}
              className="bg-orange-100 text-gray-800 font-bold px-4 py-2 rounded-full hover:bg-orange-200 transition"
            >
              Login
            </button>

            <Link
              to="/signup"
              className="bg-orange-100 text-gray-800 font-bold px-4 py-2 rounded-full hover:bg-orange-200 transition"
            >
              Signup
            </Link>

            <button
              onClick={openModal}
              className="font-semibold hover:text-orange-500 transition-colors"
            >
              Contact
            </button>
          </nav>
        </div>

        {/* Mobile Navigation */}
        {menuOpen && (
          <div className="md:hidden mt-4 flex flex-col gap-4 items-center text-gray-800">
            <Link to="/" onClick={() => setMenuOpen(false)} className={`hover:text-orange-500 transition-colors ${isActive('/') ? activeClass : ''}`}>Home</Link>
            <Link to="/features" onClick={() => setMenuOpen(false)} className={`hover:text-orange-500 transition-colors ${isActive('/features') ? activeClass : ''}`}>Features</Link>

            {/* 🆕 Blog link for mobile */}
            <Link to="/blog" onClick={() => setMenuOpen(false)} className={`hover:text-orange-500 transition-colors ${isActive('/blog') ? activeClass : ''}`}>Blog</Link>

            <button onClick={() => { handleFaqClick(); setMenuOpen(false); }} className="hover:text-orange-500 transition-colors">FAQ</button>
            
            <Link to="/signup" onClick={() => setMenuOpen(false)} className="w-3/4 text-center bg-orange-100 text-gray-800 font-bold px-4 py-2 rounded-lg hover:bg-orange-200 transition">Signup</Link>
            
            <button onClick={() => { window.open(config.signInUrl, '_blank'); setMenuOpen(false); }} className="w-3/4 text-center bg-orange-100 text-gray-800 font-bold px-4 py-2 rounded-lg hover:bg-orange-200 transition">Login</button>
            
            <button onClick={() => { openModal(); setMenuOpen(false); }} className="hover:text-orange-500 transition-colors">Contact</button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;